import "./App.css";
import Login from "./Pages/Login";
import SignUp from "./Pages/Signup";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import { ImgProvider } from "./Context/ImageCon";
import { Box, Button } from "@mui/material";

function App() {
  let token = localStorage.getItem("access_token");
  return (
    <div className="App">
      <ImgProvider>
        {token ? (
          <Box className="auth">
            <Button
              sx={{ mr: 1 }}
              variant="contained"
              color="primary"
              onClick={() => {
                localStorage.removeItem("access_token");
                window.location.reload();
              }}
            >
              Logout
            </Button>
          </Box>
        ) : (
          <Box className="auth">
            <Button
              sx={{ mr: 1 }}
              variant="contained"
              color="primary"
              href="/login"
            >
              Login
            </Button>
            <Button
              sx={{ mr: 1 }}
              variant="contained"
              color="primary"
              href="/signup"
            >
              Signup
            </Button>
          </Box>
        )}

        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
          </Routes>
        </Router>
      </ImgProvider>
    </div>
  );
}

export default App;
